import { cn } from "@/lib/utils";
import { formatPrice } from "@/utils/priceUtils";

export default function CheckoutItemPrice({
  price,
  priceOriginal,
  locale,
  prefix,
  className,
}: {
  price: number;
  priceOriginal: number;
  locale: string;
  prefix?: string;
  className?: string;
}) {
  const isDiscounted = priceOriginal > price;

  return (
    <div
      className={cn(
        "flex justify-between text-right lg:justify-self-end",
        className,
      )}
    >
      {prefix && <span className="text-sm uppercase lg:hidden">{prefix}:</span>}
      <div className="flex flex-col gap-x-1">
        {isDiscounted && (
          <span className="text-gray-300 line-through">
            {formatPrice(priceOriginal, locale)}
          </span>
        )}
        <span>{formatPrice(price, locale)}</span>
      </div>
    </div>
  );
}
